import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
export function HeroSection() {
  const scrollToCheckout = () => {
    document.getElementById('checkout')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative pt-12 pb-20 md:pt-20 md:pb-32 px-4 overflow-hidden bg-beige" data-id="element-158">
      <div className="max-w-layout mx-auto grid md:grid-cols-2 gap-12 items-center" data-id="element-159">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="flex flex-col space-y-6" data-id="element-160">
          <h1 className="font-display font-bold text-[32px] sm:text-[44px] md:text-[60px] lg:text-[64px] text-teal leading-[1.15] break-words hyphens-none [word-break:keep-all]" data-id="element-161">
            Tu cuerpo no está roto…{' '}
            <span className="italic text-sage-dark" data-id="element-162">está sobrecargado.</span>
          </h1>

          <p className="font-heading font-semibold text-base sm:text-lg md:text-xl text-neutral-gray leading-relaxed" data-id="element-163">
            Reentrena tu sistema interno en{' '}
            <span className="text-teal font-bold" data-id="element-164">30 días</span> para recuperar
            calma, energía y control emocional desde la raíz.
          </p>

          <div className="pt-4" data-id="element-165">
            <button onClick={scrollToCheckout} className="w-full md:w-auto bg-teal hover:bg-teal-light text-white font-bold py-4 px-6 md:px-8 rounded-full transition-all shadow-lg hover:shadow-[0_0_20px_rgba(39,174,96,0.4)] hover:scale-[1.03] text-base md:text-xl flex items-center justify-center gap-2" data-id="element-166">
              ✨ QUIERO MI SISTEMA AHORA
            </button>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        x: 20
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="relative" data-id="element-167">
          <div className="absolute -top-3 left-1/2 -translate-x-1/2 md:left-auto md:translate-x-0 md:right-4 z-10 flex items-center gap-2 bg-white/95 backdrop-blur-sm px-3 py-1.5 md:px-4 md:py-2 rounded-full shadow-lg border border-gold/30 whitespace-nowrap" data-id="element-168">
            <div className="flex text-gold" data-id="element-169">
              {[...Array(5)].map((_, i) => <Star key={i} size={12} fill="currentColor" data-id="element-170" />)}
            </div>
            <span className="text-[11px] md:text-sm font-bold text-teal" data-id="element-171">
              +2.400 mujeres transformadas
            </span>
          </div>

          <div className="absolute inset-0 bg-sage/20 rounded-full blur-3xl transform scale-110 -z-10" data-id="element-172"></div>
          <div className="relative rounded-2xl overflow-hidden shadow-2xl border border-white/50 aspect-[4/5] md:aspect-square bg-white" data-id="element-173">
            <img src="https://cdn.magicpatterns.com/uploads/mJoH6RHsFW4zV6N8Mw8GRc/LP1.png" alt="Mujer abrazando el libro Sistema de Reprogramación Interna de 30 Días junto a tablet con su progreso" className="w-full h-full object-cover opacity-90" data-id="element-174" />
            <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-teal/90 to-transparent p-8 pt-20" data-id="element-175">
              <div className="bg-white/10 backdrop-blur-md border border-white/20 rounded-xl p-4 text-white" data-id="element-176">
                <p className="font-heading font-bold text-sm opacity-90" data-id="element-177">
                  SISTEMA DE REPROGRAMACIÓN INTERNA™
                </p>
                <p className="text-xs opacity-75 mt-1 font-sans" data-id="element-178">
                  Protocolo de 30 días
                </p>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}